import { render } from "./RessuprimentoPulmao.vue?vue&type=template&id=5819777b&scoped=true"
import script from "./RessuprimentoPulmao.vue?vue&type=script&lang=js"
export * from "./RessuprimentoPulmao.vue?vue&type=script&lang=js"

import "./RessuprimentoPulmao.vue?vue&type=style&index=0&id=5819777b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5819777b"]])

export default __exports__